const config = {
  TRIAL_DAYS: 7,
};

export default config;
